import React from "react";

import { VSpace } from "@examspark/common-ui";
import { Classroom, ParsedTCMPCUnit } from "@examspark/types";

import UnitSummary from "../../unit/UnitSummary";

const ClassroomUnitOverview = (props: {
  classroom: Classroom;
  unit: ParsedTCMPCUnit;
}) => {
  return (
    <VSpace size="3rem">
      <UnitSummary unit={props.unit} />
    </VSpace>
  );
};

export default ClassroomUnitOverview;
